import wkTemplates from '../../../../widgets/axel-publication-content/js/templates';

const templates = wkTemplates;

export default templates;
